// extracted by mini-css-extract-plugin
export default {"mainContainer":"SearchCase_mainContainer__zPrQg"};